import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";

const VideoReview = ({ item, onChanged }) => {
  const set = (status) => api.put(`/admin/site-videos/${item.id}/status`, { status }).then(() => { toast.success(`動画を${status}にしました`); onChanged?.(); }).catch(() => toast.error("変更できませんでした"));
  return (
    <span className="mt-1 flex gap-1">
      <button type="button" data-testid={`video-approve-${item.id}`} onClick={() => set("承認")} className="border border-emerald-500/50 px-1.5 text-[10px] text-emerald-300">承認</button>
      <button type="button" data-testid={`video-reject-${item.id}`} onClick={() => set("差戻し")} className="border border-red-500/50 px-1.5 text-[10px] text-red-300">差戻し</button>
    </span>
  );
};

export const MediaThumb = ({ item, className = "h-16 w-16", testId, onChanged }) => {
  if (item.kind === "video") {
    if (item.state === "failed") return <span data-testid={testId} className={`flex items-center justify-center border border-red-500/40 bg-ink p-1 text-center text-[9px] text-red-300 ${className}`}>{item.error || "動画の変換に失敗"}</span>;
    if (item.state !== "ready") {
      return <span data-testid={testId} className={`flex flex-col items-center justify-center gap-1 border border-line bg-ink text-[9px] text-amber-300 ${className}`}><Loader2 className="h-4 w-4 animate-spin" />動画変換中</span>;
    }
    return (
      <span className="block">
        <video data-testid={testId} src={`${api.defaults.baseURL}/site-videos/${item.id}/file`} controls playsInline preload="metadata" className={`border border-line bg-black object-cover ${className}`} />
        {onChanged && <VideoReview item={item} onChanged={onChanged} />}
      </span>
    );
  }
  const url = `${api.defaults.baseURL}/site-photos/${item.id}/image`;
  return <a data-testid={testId} href={url} target="_blank" rel="noreferrer" className="block"><img src={url} alt="" className={`border border-line object-cover ${className}`} /></a>;
};
